import { AddressOverlay } from '#app/routes/mocra+/_form+/components/addresses/overlay.tsx'
import { type AddressDraft } from '#app/routes/mocra+/_form+/components/addresses/types.ts'

type Props = {
	readonly open: boolean
	readonly onOpenChange: (open: boolean) => void
	readonly onSubmit: (draft: AddressDraft) => void
	readonly initialValue: AddressDraft
	readonly title?: string
	readonly description?: string
	readonly submitLabel?: string
	readonly cancelLabel?: string
	readonly onCancel?: () => void
	readonly onClosed?: () => void
}

export function AddressEditOverlay({
	open,
	onOpenChange,
	onSubmit,
	initialValue,
	title,
	description,
	submitLabel,
	cancelLabel,
	onCancel,
	onClosed,
}: Props) {
	return (
		<AddressOverlay
			mode="edit"
			open={open}
			onOpenChange={onOpenChange}
			onSubmit={onSubmit}
			initialValue={initialValue}
			title={title}
			description={description}
			submitLabel={submitLabel}
			cancelLabel={cancelLabel}
			onCancel={onCancel}
			onClosed={onClosed}
		/>
	)
}
